<script setup lang="ts">
import { VDateInput } from 'vuetify/labs/VDateInput'
import { notifyError } from '@/utils/helpers'
import type MDBSemi from '@/types/ferme/semi'

const storeU = useUtilisateurStore()
const dialog = ref(false)
const modifications = ref(false)

const semi = ref({} as MDBSemi)
const semiSource = ref({} as MDBSemi)

const statutsNom = [
  '',
  'Date estimée',
  'En analyse',
  'Présomptif',
  'Contaminé',
  'OK'
]

//const date = computed(() => toDate_wd_dd_MMMM_hh_mm(semi.value.échantillonDate))
const aUneDate = ref(false)

let resolve: (value: boolean) => void
watch(dialog, (v) => {
  if (!v) {
    resolve(modifications.value)
  }
})

function openSemi(semiEdit: MDBSemi) {
  semiSource.value = semiEdit
  semi.value = { ... semiEdit }
  modifications.value = false

  aUneDate.value = true
  if (new Date(semi.value.échantillonDate).getFullYear() <= 2000) {
    aUneDate.value = false
    semi.value.échantillonDate = '2000-01-01T00:00:00Z'
  }

  dialog.value = true
  return new Promise<boolean>((resolveFn) => {
    resolve = resolveFn
  })
}

function aUneModification() {
  if (!aUneDate.value) {
    semi.value.échantillonDate = '2000-01-01T00:00:00Z'
  }
  else {
    const date = new Date(semi.value.échantillonDate)
    date.setHours(12)
    semi.value.échantillonDate = date.toISOString()
  }

  if (semiSource.value.échantillonDate != semi.value.échantillonDate ||
      semiSource.value.échantillonStatut != semi.value.échantillonStatut ||
      semiSource.value.échantillonCommentaires != semi.value.échantillonCommentaires)
    return true

  return false
}

async function confirm() {
  try
  {
    if (!aUneModification()) {
      dialog.value = false
      return
    }

    const siteCS = storeU.siteSélectionné?.lettresDappel

    await apiProphet.put(`sites/${siteCS}/semis/${semi.value.id}/echantillon`, semi.value)
    Notify.success('Modification du semi avec succès');

    modifications.value = true
    dialog.value = false
  }
  catch (e) {
    notifyError(e)
  }
}

function cancel() {
  dialog.value = false
}

function dateChange() {
  aUneDate.value = !aUneDate.value
  if (!aUneDate.value) {
    semi.value.échantillonDate = '2000-01-01T00:00:00Z'
  } else {
    semi.value.échantillonDate = new Date().toISOString()
  }
}

onMounted(async () => {
  if (!storeU.siteSélectionné) {
    Notify.error('Veuillez sélectionner un site')
    cancel()
    return
  }
})

defineExpose({ openSemi })
</script>

<template>
  <v-dialog v-model="dialog" max-width="800px" :fullscreen="$vuetify.display.smAndDown">
    <v-card style="z-index: -1">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5 text-medium-emphasis ps-2">Modifier semi</span>
        <v-btn icon="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" variant="text" @click="cancel"/>
      </v-card-title>

      <v-divider class="mb-4"/>

      <v-card-text>
        <v-container/>
          <v-row>
            <v-col cols="12">

              <!--<v-date-input
                v-if="aUneDate" v-model="semi.échantillonDate" label="Date de l'échantillon"
                display-format="normalDateWithWeekday" prepend-icon=""/>
              <v-btn
                color="secondary"
                variant="flat"
                :text="aUneDate ? 'Supprimer date échantillon' : 'Ajouter date échantillon'"
                @click="dateChange"/>-->

              <v-text-field
                v-if="!aUneDate" label="Date de l'échantillon"
                model-value="Aucune date" readonly density="compact" variant="outlined"
                append-icon="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" @click:append="dateChange" />
              <v-date-input
                v-else v-model="semi.échantillonDate" label="Date de l'échantillon" prepend-icon=""
                append-icon="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M9,8H11V17H9V8M13,8H15V17H13V8Z"
                @click:append="dateChange"/>

              <v-select v-model="semi.échantillonStatut" class="pt-4" width="500px" :items="statutsNom" label="État" outlined dense/>
              <v-textarea v-model="semi.échantillonCommentaires" rows="2" label="Commentaires" required/>
            </v-col>
          </v-row>
      </v-card-text>

      <v-divider class="mt-2"/>

      <v-card-actions class="d-flex justify-end mr-2 my-2">
        <v-btn @click="cancel">Annuler</v-btn>
        <v-btn color="primary" variant="flat" @click="confirm">Modifier le semi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
